import React from 'react'
import { FormHelperText, Typography } from '@mui/material'
import { FormControl } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Dayjs } from 'dayjs'
import tw from 'twin.macro'

interface Props {
  name?: string
  label?: string
  /** `null` is a controlled empty field; `undefined` leaves the picker uncontrolled. */
  value?: Dayjs | null
  error?: boolean
  helperText?: string | false
  /** Earliest selectable day. Optional, so existing callers are unaffected. */
  minDate?: Dayjs
  /** Latest selectable day. Optional, so existing callers are unaffected. */
  maxDate?: Dayjs
  /** Optional, so existing callers are unaffected. */
  disabled?: boolean
  /** Stretch the field to its container. Optional — existing callers keep the intrinsic width. */
  fullWidth?: boolean
  onChange(date: Dayjs | null): void
}

export interface BasicSelectOption {
  label: string
  value: string | number
}

export const BasicDatePicker = ({
  label,
  value,
  error,
  helperText,
  minDate,
  maxDate,
  disabled,
  fullWidth = false,
  onChange,
}: Props) => {
  return (
    <FormControl fullWidth error={error}>
      <div css={tw`space-y-1`}>
        <Typography variant="h6" css={tw`text-shades-400`}>
          {label}
        </Typography>
        <DatePicker
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          slotProps={fullWidth ? { textField: { fullWidth: true } } : undefined}
          onChange={onChange}
        />
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </div>
    </FormControl>
  )
}
